import * as yup from 'yup';

export const PayerSchema = yup.object({
  name: yup.string().required('Payer name is required'),
  code: yup.string().required('Code is required'),
  isActive: yup.boolean(),
  takeDeposit: yup?.boolean(),
  depositAmount: yup?.number(),
});
